import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from '@mui/material';

interface ConfirmDayDialogProps {
    open: boolean;
    onConfirm: (message: string) => void;
    onClose: () => void;
}

const ConfirmDayDialog: React.FC<ConfirmDayDialogProps> = ({ open, onConfirm, onClose }) => {
    const [message, setMessage] = useState('');

    const handleConfirm = () => {
        onConfirm(message);
        setMessage('');
    };

    const handleClose = () => {
        setMessage('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Confirmer la journée</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Message (optionnel)"
                    type="text"
                    fullWidth
                    multiline
                    rows={3}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Ajoutez un message pour cette journée..."
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Annuler</Button>
                <Button onClick={handleConfirm} variant="contained" color="primary">
                    Confirmer
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDayDialog;
